import React from "react";

interface PaymentMethodSelectorProps {
  selected: string;
  onSelect: (method: "Cash" | "Buy on credit") => void;
}

const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({ selected, onSelect }) => (
  <div className="pay-drawer-methods">
    <h3 className="font-semibold">Payment methods:</h3>
    <div className="flex justify-around">
      {["Card", "Cash"].map((method) => (
        <button
          key={method}
          type="button"
          onClick={() => onSelect(method as "Cash" | "Buy on credit")}
          className={`w-20 h-20 rounded-full border font-bold transition ${selected === method ? "bg-blue-600 text-white" : "bg-white text-black hover:bg-blue-50"}`}
        >
          {method}
        </button>
      ))}
    </div>
  </div>
);

export default PaymentMethodSelector;
